export default __webpack_public_path__ + "static/media/icomoon.774df96c.eot";